<template>
    <v-text-field :model-value="display" :class="{ 'text-error': unpartitioned < 0 }" disabled />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatArea } from '@shared/utils/formatArea';

const props = defineProps<{
    total: number;
    partitioned: number;
    unpartitioned: number;
}>();

const display = computed(() => `${formatArea(props.partitioned)} / ${formatArea(props.total)} ha`);
</script>
